import { Circle, HStack, Text, useToken } from '@chakra-ui/react';

import { NavLink } from './useSideNavigation';
import { hexToRGBA } from '@/client/utils/hexToRGBA';

export default function InnerParentLink({
  navLink,
  navOpen,
}: {
  navLink: NavLink;
  navOpen: boolean | undefined;
}) {
  const [brandColor] = useToken('colors', ['brand.primary']);

  return (
    <HStack spacing={2}>
      <Circle backgroundColor={hexToRGBA(brandColor, 0.1)} color="neutral.1500" size="32px">
        {navLink.icon}
      </Circle>

      {navOpen && <Text>{navLink.name}</Text>}
    </HStack>
  );
}
